import { FC, ComponentProps } from 'react';
import { IFeatureBase } from 'mod/featureV2/interface';
import cn from 'classnames';

export type IProps = ComponentProps<'div'> & {
    feature?: IFeatureBase;
};

export const FeatureDescription: FC<IProps> = ({ className, feature }) => {
    const { description, theme, } = feature || {};
    const { descClassName } = theme || {};
    return !description ? null : (
        <div
            className={cn('g-feature-desc', descClassName, className)}
            dangerouslySetInnerHTML={{ __html: description }}
        />
    )
};
